import { apiAddress } from '../ApiPlatform';

export const API_SELECT_MENU_LIST = apiAddress + '/menu/select';
export const API_INSERT_MENU = apiAddress + '/menu/insert';
export const API_UPDATE_MENU = apiAddress + '/menu/update';
export const API_SELECT_PRIMARY_MENU = apiAddress + '/menu/selectPrimaryMenu';
